

// export const BaseUrl = 'https://foodweb-beaver.ksoftpl.com/beaver-backend/public/api';
// export const AssetsUrl = 'https://foodweb-beaver.ksoftpl.com/beaver-backend/public/'; 

global.BaseUrl = 'https://admin.foodweb-beaver.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-beaver.ksoftpl.com';


